
/** @param {import('@clabroche/common-typings').StackMonitor} stackMonitor */
const NodeRed = (stackMonitor) => {
  
}

module.exports = NodeRed